import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinvasiaComponent } from './finvasia.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgxTelInputModule } from '@shared/module/ngx-tel-input/ngx-tel-input.module';



@NgModule({
  declarations: [
    FinvasiaComponent
  ],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    AppNgxTelInputModule
  ]
})
export class FinvasiaModule { }
